/**
 * @engine/vfx - Operator Nodes
 *
 * Math, random, and utility nodes available in any context.
 */

import type { VFXNodeDefinition } from '../../types';
import { dataPort } from '../../types';

/**
 * Operator node definitions.
 */

export const ATTRIBUTE_NODES: readonly VFXNodeDefinition[] = [

  {
    id: 'vfx.operator.get_position',
    name: 'Get Position',
    category: 'attribute',
    contexts: [],
    description: 'Get particle position',
    color: '#00BCD4',
    inputs: [],
    outputs: [dataPort('position', 'Position', 'vec3')],
    shader: {
      code: `position = particle.position;`,
    },
  },

  {
    id: 'vfx.operator.get_velocity',
    name: 'Get Velocity',
    category: 'attribute',
    contexts: [],
    description: 'Get particle velocity',
    color: '#00BCD4',
    inputs: [],
    outputs: [dataPort('velocity', 'Velocity', 'vec3')],
    shader: {
      code: `velocity = particle.velocity;`,
    },
  },

  {
    id: 'vfx.operator.get_age',
    name: 'Get Age',
    category: 'attribute',
    contexts: [],
    description: 'Get particle age (0-1 normalized)',
    color: '#00BCD4',
    inputs: [],
    outputs: [
      dataPort('age', 'Age', 'float'),
      dataPort('normalizedAge', 'Normalized', 'float'),
    ],
    shader: {
      code: `
        age = particle.lifetime;
        normalizedAge = particle.lifetime / particle.maxLifetime;
      `,
    },
  },

  {
    id: 'vfx.operator.get_color',
    name: 'Get Color',
    category: 'attribute',
    contexts: [],
    description: 'Get particle color',
    color: '#00BCD4',
    inputs: [],
    outputs: [dataPort('color', 'Color', 'color')],
    shader: {
      code: `color = particle.color;`,
    },
  },

  {
    id: 'vfx.operator.get_size',
    name: 'Get Size',
    category: 'attribute',
    contexts: [],
    description: 'Get particle size',
    color: '#00BCD4',
    inputs: [],
    outputs: [dataPort('size', 'Size', 'float')],
    shader: {
      code: `size = particle.size;`,
    },
  },


  {
    id: 'vfx.operator.get_particle_index',
    name: 'Get Particle Index',
    category: 'attribute',
    contexts: [],
    description: 'Get unique particle index (0 to maxParticles-1)',
    color: '#00BCD4',
    inputs: [],
    outputs: [
      dataPort('index', 'Index', 'uint'),
    ],
    shader: {
      code: `index = idx;`,
    },
  },
];
